import React, { useEffect } from "react";

import { Row, Col } from "react-bootstrap";
import FASTable from "../../../../../components/Tables/FASTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import {
  BankFasTdsPay,
  BankFasTdsPayFun,
} from "../../../../../Redux/Slice/Fas/DayBook Analysis/Bank/BankSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export const TdsPayable = ({ tdsName, natureOfParty, startDate, endDate }) => {
  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { BankFasTdsPaydata } = useSelector((state) => state.BankSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");
  const YearId = Cookies.get("FinancialYear");

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  useEffect(() => {
    dispatch(BankFasTdsPayFun());
    dispatch(
      BankFasTdsPay({
        Firm,
        Year: YearId,
        NaturePayment: natureOfParty?.join(",") || "",
        TDSAc: tdsName?.join(",") || "",
        startDate: startDate,
        endDate: endDate,
      }),
    );
  }, [dispatch, tdsName, natureOfParty, startDate, endDate]);

  const getRows = BankFasTdsPaydata?.Dtl?.map((label, index) => ({
    // srNumber: index + 1,
    VNo: label.VNo,
    Type: label.Type,
    BillNo: label.BillNo,
    AcName: label.AcName,
    PanNo: label.PanNo,
    BillAmount: label.BillAmount,
    TDSRate: label.TDSRate,
    TDSPAmt: label.TDSPAmt,
    PaidTDS: label.PaidTDS,
    IGSTAmt: label.IGSTAmt,
    TdsTypeshName: label.TdsTypeshName,
    DateOfDeduction: formatDateToDDMMYYYY(label.DateOfDeduction),
    PaidDate: formatDateToDDMMYYYY(label.PaidDate),
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Vou No", key: "VNo", align: "left" },
    {
      label: "Date Of Deduction",
      key: "DateOfDeduction",
      align: "left",
    },
    { label: "Paid Date", key: "PaidDate", align: "left" },
    {
      label: "Type",
      key: "Type",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Bill No", key: "BillNo", align: "left" },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Pan No",
      key: "PanNo",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Tds TypeName",
      key: "TdsTypeshName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Bill Amount",
      key: "BillAmount",
      align: "right",
      format: "true",
    },
    {
      label: "TDS Rate",
      key: "TDSRate",
      align: "right",
      format: "true",
    },
    {
      label: "TDSP Amt",
      key: "TDSPAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Paid TDS",
      key: "PaidTDS",
      align: "right",
      format: "true",
    },
  ];

  const getRows2 = BankFasTdsPaydata?.Summ?.map((label, index) => ({
    // srNumber: index + 1,
    AcName: label.AcName,
    PanNo: label.PanNo,
    BillAmount: label.BillAmount,
    TDSRate: label.TDSRate,
    TDSPAmt: label.TDSPAmt,
    PaidTDS: label.PaidTDS,

    TdsTypeshName: label.TdsTypeshName,
  }));

  const getColumns2 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Pan No",
      key: "PanNo",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Tds TypeName",
      key: "TdsTypeshName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Bill Amount",
      key: "BillAmount",
      align: "right",
      format: "true",
    },
    {
      label: "TDS Rate",
      key: "TDSRate",
      align: "right",
      format: "true",
    },
    {
      label: "TDS Amt",
      key: "TDSPAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Paid TDS",
      key: "PaidTDS",
      align: "right",
      format: "true",
    },
  ];

  if (BankFasTdsPaydata === "no" || BankFasTdsPaydata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <Row className="g-4">
      <Col xl={12}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              DETAIL
            </h2>
          </div>

          <FASTable data={getRows} columns={getColumns} />
        </div>
      </Col>

      <Col xl={12}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              SUMMARY
            </h2>
          </div>
          <FASTable data={getRows2} columns={getColumns2} />
        </div>
      </Col>
    </Row>
  );
};
